import { lazy } from "react";
import ProductsManagementPage from "../pages/main/products/products";
import BrandsManagementPage from "../pages/main/brands/brands";
import SubscriptionsManagementPage from "../pages/main/subscriptions/mainSubscription";
// import InsuranceManagementPage from "../pages/main/Insurance/insurance";
import ReportsManagementPage from "../pages/main/reports/reports";
import ModelManagementPage from "../pages/main/model/model";
import BlogsManagementPage from "../pages/main/blog/blogs";
import FaqsManagementPage from "../pages/main/faq/faq";
import DevicesManagementPage from "../pages/main/devices/deviceTab";
import DisputeManagementPage from "../pages/main/devices/disputeTab";
import BusinessManagementPage from "../pages/main/business/businessTab";
import AdServices from "../pages/main/adservices/adservices";
import CreateInsurance from "../pages/auth/createInsurance";
import InsuredPackage from "../pages/main/InsuredCompanies/InsuredPackage/insuredPackage";
import InsuredDevice from "../pages/main/InsuredCompanies/InsuredDevice/insuredDevice";
import TransactionPage from "../pages/main/reports/transaction";


// authentication pages imports 
const LoginPage = lazy(() => import("../pages/auth/login"));
const ForgotPage = lazy(() => import("../pages/auth/forgot"));
const ResetPage = lazy(() => import("../pages/auth/reset"));
const OTPPage = lazy(() => import("../pages/auth/otp"));
const ConfirmPage = lazy(() => import("../pages/auth/confirm"));
const LogoutPage = lazy(() => import("../pages/auth/logout"));


// main pages imports 
const Dashboard = lazy(() => import("../pages/main/dashboard"));
const EventManagement = lazy(() => import("../pages/main/events"));
const QrCodesPage = lazy(() => import("../pages/main/qr-codes"));
const AdminManagement = lazy(() => import("../pages/main/users"));
const UserManagement = lazy(() => import("../pages/main/users/user"));
const InviteeManagement = lazy(() => import("../pages/main/invitees"));
const InsuranceManagementPage = lazy(() => import("../pages/main/Insurance/insurance"));
// const EventGallery = lazy(() => import("../pages/main/gallery"));
const Settings = lazy(() => import("../pages/main/settings"));


export const routes = [
  // main pages with no initial path
  {
    path: "/",
    label: "Dashboard",
    component: <Dashboard />
  },
  {
    path: "/event-management",
    label: "Event management",
    component: <EventManagement />
  },
  {
    path: "/admin-management",
    label: "Admin management",
    component: <AdminManagement />
  },
  {
    path: "/user-management",
    label: "User management",
    component: <UserManagement />
  },
  {
    path: "/invitee-management",
    label: "Invitee management",
    component: <InviteeManagement />
  },
  {
    path: "/products-management",
    label: "Products management",
    component: <ProductsManagementPage />
  },
  {
    path: "/brands-management",
    label: "Brands management",
    component: <BrandsManagementPage />
  },
  {
    path: "/ads-services",
    label: "Ads Services",
    component: <AdServices />
  },
  {
    path: "/models-management",
    label: "Models management",
    component: <ModelManagementPage />
  },
  {
    path: "/subscription-management",
    label: "Subscription management",
    component: <SubscriptionsManagementPage />
  },
  {
    path: "/insurance-management",
    label: "Insurance management",
    component: <InsuranceManagementPage />
  },
  {
    path: "/business-management",
    label: "Business management",
    component: <BusinessManagementPage />
  },
  {
    path: "/devices-management",
    label: "Devices management",
    component: <DevicesManagementPage />
  }, 
  {
    path: "/dispute-management",
    label: "Dispute management",
    component: <DisputeManagementPage />
  }, 
  {
    path: "/transactions",
    label: "Transactions",
    component: <ReportsManagementPage />
  },
  {
    path: "/insure-transactions",
    label: "TransactionsInsure",
    component: <TransactionPage />
  },
  {
    path: "/faqs",
    label: "FAQs management",
    component: <FaqsManagementPage />
  }, // package-management
  {
    path: "/blogs",
    label: "Blog",
    component: <BlogsManagementPage />
  },

  // insurance Companies
  {
    path: "/package-management",
    label: "Packages",
    component: <InsuredPackage />
  },
  {
    path: "/devices",
    label: "Devices",
    component: <InsuredDevice />
  },

  
  // End insurance Companies
  {
    path: "/settings",
    label: "Settings",
    component: <Settings />
  },
  {
    path: "/qr-codes",
    label: "QR Codes",
    component: <QrCodesPage />
  },

  // authentication pages with initial path of /auth
  {
    label: "Login",
    path: "/auth/login",
    component: <LoginPage />
  },
  {
    label: "Forget Password",
    path: "/auth/forgot-password",
    component: <ForgotPage />
  },
  {
    label: "Reset",
    path: "/auth/reset-password",
    component: <ResetPage />
  },
  {
    label: "OTP",
    path: "/auth/otp",
    component: <OTPPage />
  },
  {
    label: "Confirm Mail",
    path: "/auth/confirm",
    component: <ConfirmPage />
  },
  {
    label: "CreateInsurance",
    path: "/auth/verivault-insurance",
    component: <CreateInsurance />
  },
  {
    label: "Logout",
    path: "/auth/logout",
    component: <LogoutPage />
  },
]